export class MetricsAnalysis {
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;

  public yearly: any;
  public one_year: any;
  public three_years: any;
  public cushion_historical_values: any;
  public risky_part_historical_values: any;
  public historical_values: any;
  public floor_historical_values: any;

  constructor() {}

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.creation_date                = data.creation_date ? new Date(data.creation_date) : undefined;
    this.inception_date               = data.inception_date ? new Date(data.inception_date) : undefined;
    this.last_date                    = data.last_date ? new Date(data.last_date) : undefined;

    this.yearly                       = data.yearly ? data.yearly : undefined;
    this.one_year                     = data.one_year ? data.one_year : undefined;
    this.three_years                  = data.three_years ? data.three_years : undefined;
    this.cushion_historical_values    = data.cushion_historical_values ? data.cushion_historical_values : undefined;
    this.risky_part_historical_values = data.risky_part_historical_values ? data.risky_part_historical_values : undefined;
    this.historical_values            = data.historical_values ? data.historical_values : undefined;
    this.floor_historical_values      = data.floor_historical_values ? data.floor_historical_values : undefined;
  }
}
